import { Checkbox, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import classnames from "classnames";
import { CopyableWrapper } from "components/fields/CopyableWrapper";
import { DateTimeField } from "components/fields/DateFormatField";
import { envSettings } from "core/EnvSettings";
import React from "react";
import { ArrayField, Datagrid, FunctionField, NumberField, TextField } from "react-admin";

import { CopyableStorageLinkChip } from "../PalletsAndBoxes/components/StorageLinkChip";
import { BoxesButton } from "./BoxesButton";

const useStyles = makeStyles(() => ({
	datagrid: {
		"& .MuiTableRow-root": {
			height: 48,
		},
		"& .MuiTableCell-root": {
			paddingTop: 6,
			paddingBottom: 6,
		},
	},
}));

const rowHighlightStyle = (isHighlighted) => ({
	backgroundColor: isHighlighted ? "rgba(33, 150, 243, 0.1)" : "inherit",
});

export const BoxMovementsGrid = ({
	translate,
	pallet,
	terminalId,
	storagePlaces,
	showActions = false,
	isActionsDisabled = false,
	isConfirmMode = false,
	onDeleteMovement,
	selectedBoxMovements = [],
	onSelectBoxMovement,
	className,
}) => {
	const classes = useStyles();
	return (
		<ArrayField source="box_movements" record={pallet}>
			<Datagrid
				className={classnames(classes.datagrid, className)}
				rowStyle={(record) => {
					if (isConfirmMode) {
						return rowHighlightStyle(selectedBoxMovements.includes(record.id));
					}
					return rowHighlightStyle(record.completed_at);
				}}
			>
				<FunctionField
					label={translate("tab.pallets.boxes_button")}
					render={(record) => <BoxesButton record={record} />}
				/>
				{isConfirmMode && (
					<FunctionField
						label=""
						render={(record) => (
							<Checkbox
								checked={selectedBoxMovements.includes(record.id)}
								onChange={() => onSelectBoxMovement?.(record.id)}
								size="small"
								color="primary"
							/>
						)}
					/>
				)}
				<NumberField
					source="source_pallet_id"
					label={translate("tab.picking_list.source_pallet_id")}
				/>
				<CopyableWrapper
					source="source_pallet_sscc"
					label={translate("tab.picking_list.source_sscc")}
				>
					<TextField />
				</CopyableWrapper>
				<CopyableWrapper source="ceel_number" label={translate("tab.picking_list.ceel_number")}>
					<TextField />
				</CopyableWrapper>
				<NumberField source="quantity" label={translate("tab.picking_list.quantity")} />
				<NumberField
					source="total_weight"
					label={translate("tab.picking_list.box_movement.total_weight")}
				/>
				<FunctionField
					label={translate(
						`tab.pallets.${
							envSettings.REACT_APP_FF_STORAGE_MODULE ? "storage_place_id" : "area_id"
						}`
					)}
					render={(record) => (
						<CopyableStorageLinkChip
							pallet={{
								id: record.source_pallet_id,
								storage_place_id: record.storage_place_id,
								is_storage_place_confirmed: record.is_storage_place_confirmed,
								into_preparation_place: record.is_into_preparation_place,
							}}
							terminalId={terminalId}
							storagePlaces={storagePlaces}
						/>
					)}
				/>
				<CopyableWrapper source="product_number" label={translate("tab.pallets.product_number")}>
					<TextField />
				</CopyableWrapper>
				<CopyableWrapper source="product_name" label={translate("tab.picking_list.product_name")}>
					<TextField />
				</CopyableWrapper>
				<DateTimeField source="created_at" label={translate("tab.picking_list.created_at")} />
				<DateTimeField source="completed_at" label={translate("tab.picking_list.completed_at")} />
				{showActions && (
					<FunctionField
						label={translate("ra.action.delete")}
						render={(record) => {
							if (record.completed_at) return null;
							return (
								<IconButton
									size="small"
									color="secondary"
									disabled={isConfirmMode || isActionsDisabled}
									onClick={() => onDeleteMovement?.(record.id)}
								>
									<DeleteIcon fontSize="small" />
								</IconButton>
							);
						}}
					/>
				)}
			</Datagrid>
		</ArrayField>
	);
};
